export const servicesData = [
    {
        icon: "fa-car",
        title: "City Taxi Service",
        description: "Reliable and affordable taxi service for city travel, ensuring comfort and safety.",
    },
    {
        icon: "fa-plane",
        title: "Airport Transfers",
        description: "Seamless airport pickups and drop-offs to ensure you never miss a flight.",
    },
    {
        icon: "fa-map-signs",
        title: "Tour Packages",
        description: "Explore popular tourist destinations with our customizable tour packages.",
    },
    {
        icon: "fa-route",
        title: "One Way Travel",
        description: "Convenient one-way taxi services for flexible and cost-effective travel.",
    },
    {
        icon: "fa-exchange-alt",
        title: "Round Trip Cabs",
        description: "Book round-trip cabs for hassle-free travel to and from your destination.",
    },
    {
        icon: "fa-road",
        title: "Outstation Taxi",
        description: "Comfortable and safe outstation taxi services for long-distance travel.",
    },
    {
        icon: "fa-briefcase",
        title: "Corporate Travel",
        description: "Professional and punctual cab services for business meetings and corporate events.",
    },
    {
        icon: "fa-bus",
        title: "Tempo Traveller",
        description: "Spacious tempo travellers for group outings, family trips, or corporate events.",
    },
];